import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=07ecd08e&scoped=true&"
var script = {}
import style0 from "./company-info.vue?vue&type=style&index=0&id=07ecd08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ecd08e",
  null
  
)

export default component.exports